import React from 'react';
import { paymentCopy } from './CartService';
import { FaCheckCircle, FaExclamationTriangle, FaSpinner } from 'react-icons/fa';
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import './stripe.css';
import { useTranslation } from '../../store/context/TranslationContext';
import { buildAutomationChildTestId, buildAutomationValueTestId, resolveAutomationTestId } from '../InputField/testId';

const PaymentStatusCard = ({ variant, onRetry, testId }) => {
    const { t } = useTranslation();
    const resolvedTestId = resolveAutomationTestId(testId, buildAutomationValueTestId("payment-status", variant));

    let icon, title, descr;
    if (variant === 'processing') {
        icon = <FaSpinner className="fv_pay_now_status_icon fa-spin" />;
        title = paymentCopy.processing_title;
        descr = paymentCopy.processing_message;
    } else if (variant === 'success') {
        icon = <FaCheckCircle className="fv_pay_now_status_icon" />;
        title = paymentCopy.completed_title;
        descr = paymentCopy.completed_message;
    } else {
        icon = <FaExclamationTriangle className="fv_pay_now_status_icon" />;
        title = paymentCopy.error_title;
        descr = paymentCopy.error_message;
    }
    return (
        <div className={`fv_pay_now_status_card fv_pay_now_${variant}`} data-testid={resolvedTestId}>
            <span data-testid={buildAutomationChildTestId(resolvedTestId, "icon")}>{icon}</span>
            <h3 className="fv_pay_now_status_title" data-testid={buildAutomationChildTestId(resolvedTestId, "title")}>{t(title)}</h3>
            <p className="fv_pay_now_status_text" data-testid={buildAutomationChildTestId(resolvedTestId, "description")}>{t(descr)}</p>
            {variant === 'error' && (
                <PrimaryButton
                    data-testid={buildAutomationChildTestId(resolvedTestId, "retry")}
                    className="fv_pay_now_retry_button"
                    onClick={onRetry}
                >
                    {t(paymentCopy.retry)}
                </PrimaryButton>
            )}
        </div>
    );
};

export default PaymentStatusCard
